import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SaveButtonComponent} from "../save-button/save-button.component";
import {CancelButtonComponent} from "../cancel-button/cancel-button.component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'save-and-cancel-buttons',
    imports: [
        SaveButtonComponent,
        CancelButtonComponent
    ],
    standalone: true,
    templateUrl: './save-and-cancel-buttons.component.html',
    styleUrl: './save-and-cancel-buttons.component.css'
})
export class SaveAndCancelButtonsComponent {
    @Input() canSave: boolean | null = true;
    @Output() save = new EventEmitter<void>();

    public doSave() {
        this.save.emit();
    }
}
